import { SimpleUploader, DataList, AutoRouter, CrudRouter } from "javaee-fre";
const StuClazzList = () => import("../views/stuclazz-list.vue");
const StuClazzRecordList = () => import("../views/stuclazz-record-list.vue");
import { orgTree } from "./comm-func.js";

const RowFlag = () => import("../components/row-flag.vue");
function stuListItemActs(url) {
    return [
        {
            label: '学习档案', order: -2, icon: 'library_books', func(cfg) {
                let self = this;
                self.$router.push(`/console/home/admin/my/tenant/${url}/clzstu/${cfg.item.id}`, `学习档案 - ${cfg.item._name || cfg.item.name}`);
            }
        },
        {
            label: '照片', order: -3, icon: 'face', func(cfg) {
                let self = this, idPhoto = cfg.item.idPhoto.split('/')[0];
                self.$dialog.img(`初始照片 - ${cfg.item._name || cfg.item.name}`, { src: `${self.$const.baseUrl}/home/admin/my/tenant/stu/photo/${cfg.item.id}/${idPhoto}`, width: 300 });
            }
        },
        {
            label: '年学习证明', order: -4, icon: 'more_horiz', func(cfg) {
                let self = this;
                self.$dialog.month('选择截至月份', {}, [{
                    label: '确认', color: 'primary', func(date) {
                        if (date) {
                            window.open(`${self.$const.baseUrl}/home/admin/my/tenant/stu/report/year/detail/${cfg.item.id}/${date}/html`);
                        }
                    }
                }]);
            }
        }
    ];
}
function stuMeta(i, tree) {
    let q = q = i ? ('_orgId=' + i.id) : '';
    return {
        titleField: '_name',
        params: { _tree: tree, _orgId: i ? i.id : null },
        createable() {
            let a = this.$store.state.account;
            return a.orgType == 1 || (!a.orgId && a.tenantOrgCount == 0) || (i && i.type == 1);
        },
        listActions() {
            let acts = [{
                order: -1,
                label: '导出', func() {
                    let self = this, count = self.total;
                    if (count <= self.$const.LAZY_TASK_THRESHOLD) {
                        if (self.searching) {
                            window.open(`${self.$const.baseUrl}/home/admin/my/tenant/stu/export?_count=${count}&_tree=true&${q}&${self.$qs.stringify(self.searchData())}`);
                        } else {
                            window.open(`${self.$const.baseUrl}/home/admin/my/tenant/stu/export?_count=${count}&_tree=true&${q}`);
                        }
                        return;
                    }
                    let params = { _count: count, _tree: true, _orgId: i ? i.id : null }
                    if (self.searching) {
                        Object.assign(params, self.searchData());
                    }
                    self.$axios.get('/home/admin/my/tenant/stu/export', { params: params }).then(r => {
                        if (r.data.status == 'ok') {
                            self.$status(self.data.message, 'success');
                            self.$store.commit('rightDrawer', 'myTaskShow');
                            return;
                        }
                        self.$status(self.data.message || '导出错误～', 'error');
                    })
                }
            }], self = this, a = self.$store.state.account;
            if (a.orgType == 1 || (!a.orgId && a.tenantOrgCount == 0) || (i && i.type == 1)) {
                acts.push({
                    label: '导入', func() {
                        let self = this;
                        self.$dialog.component('导入', SimpleUploader, {
                            width: 600,
                            persist: true,
                            url: `/home/admin/my/tenant/stu/import?${q}`,
                            templateUrl: '/s/a/stu_import.xlsx',
                            onUploadComplete(r) {
                                if (!r.data) {
                                    return;
                                }
                                let s = r.data.status, msg = r.data.message;
                                if (s == 'ok') {
                                    if (r.data.task) {
                                        self.$status(msg, 'success');
                                        self.$dialog.close();
                                        self.$store.commit('rightDrawer', 'myTaskShow');
                                    } else {
                                        if (r.data.excelErrors && r.data.excelErrors.length > 0) {
                                            self.$dialog.component('有问题未导入列表', DataList, {
                                                width: 600,
                                                heads: [{ label: '行', name: 'row' }, { label: '列', name: 'col' }, { label: '说明', name: 'message' }],
                                                data: r.data.excelErrors
                                            });
                                        } else {
                                            self.$dialog.close();
                                        }
                                        self.$status(`导入完成！成功导入${msg}条，未导入${r.data.unParsed}。`, 'success');
                                    }
                                    self.refresh();
                                } else {
                                    self.$dialog.close();
                                    self.$status(r.data ? r.data.message : '导入出现错误', 'error');
                                }
                            }
                        });
                    }
                }, {
                    order: -3,
                    label: '离职人员', func() {
                        let that = this;
                        this.$dialog.crud('离职人员', {
                            url: 'home/admin/my/tenant/resign/stu',
                            editable: false,
                            params: { _orgId: i ? i.id : null },
                            listItemActions: [{
                                label: '上岗', icon: 'work', func(cfg) {
                                    let self = this;
                                    self.$axios.get(`/home/admin/my/tenant/resign/stu/up/${cfg.item.id}`).then((r) => {
                                        if (r.data && r.data.status == 'ok') {
                                            self.$status(r.data.message, 'success');
                                            self.refresh();
                                            that.refresh();
                                            return;
                                        }
                                        self.$status(r.data && r.data.message ? r.data.message : '出现错误', "error");
                                    });
                                }
                            }],
                            listItemFilter(i, acts) {
                                let act = acts.find(a => a.icon == "work");
                                act.confirm = "确认对该人员执行上岗操作吗？";
                                return acts;
                            }
                        });
                    }
                });
            }
            return acts;
        },
        listItemActions: [{
            label: '修改密码', order: -1, icon: 'vpn_key', func(cfg) {
                this.$parent.onEdit(cfg.item.id, { _chgpwd: true });
            }
        },
        {
            label: '离职', icon: 'work_off', func(cfg) {
                let self = this;
                //选择离职日期
                self.$dialog.date('请选择离职日期', {}, [{
                    label: '确认', color: 'primary', func(date) {
                        self.$axios.get(`/home/admin/my/tenant/stu/resign/${cfg.item.id}`, { params: { date: date } }).then((r) => {
                            if (r.data && r.data.status == 'ok') {
                                self.$status(r.data.message, 'success');
                                self.refresh();
                                return;
                            }
                            self.$status(r.data && r.data.message ? r.data.message : '出现错误', "error");
                        });
                    }
                }]);
            }
        },
        {
            label: '确认', order: -5, confrim: '确认将开放注册用户转为正式用户？', icon: 'check', func(cfg) {
                let self = this;
                self.$axios.get(`/home/admin/my/tenant/stu/confirm/${cfg.item.id}`).then(() => {
                    self.$status('确认成功～', 'success');
                    self.refresh();
                });
            }
        },
        ...stuListItemActs('stu')],
        listItemFilter(i, acts) {
            if (i.online) {
                i._name = i.name;
                i.name = {
                    _component: {
                        name: RowFlag,
                        cfg: {
                            val: i.name,
                            color: 'green',
                            flag: '在线'
                        }
                    }
                }
            }
            if (!i.idPhoto) {
                this.delAction(acts, "icon", "face");
            }
            if (i.confirmed) {
                this.delAction(acts, "icon", "check");
            }
            return acts;
        }
    };
}
const routers = [{
    path: 'home/admin/my/tenant/stu', component: AutoRouter, meta() {
        let self = this, a = self.$store.state.account, orgType = a.orgType;
        if (orgType == 1 || (!a.orgId && a.tenantOrgCount == 0)) {
            return stuMeta(null, false);
        }
        return {
            tree: orgTree(true),
            acceptEmptyActive: true,
            crud(i) {
                return {
                    genParams(i) {
                        return { _org: i ? i.id : null };
                    },
                    ...stuMeta(i, true)
                }
            }
        }
    },
    children: [
        {
            path: 'clzstu/:_stuId', component: StuClazzRecordList
        }
    ]
},
{
    path: 'home/admin/my/tenant/clzstu', component: StuClazzList
},
{
    path: 'home/admin/my/tenant/ex_stu', component: CrudRouter, meta: {
        desc: '<p class="sys-alert">敬告：系统检测到以下学员具有翻拍照片、代刷学时等作弊行为，请各企业及时关注学员学习数据，给予问题学员警告教育，并对产生的学习数据合理使用，合规合法履行企业安全培训主体责任。<br/>如有其他疑问，请联系专门对接的服务人员。</p>',
        name: '异常学员', url: '/home/admin/my/tenant/stu/except',
        listItemActions: stuListItemActs('ex_stu'), listItemFilter(i, acts) {
            if (!i.idPhoto) {
                this.delAction(acts, "icon", "face");
            }
            return acts;
        }
    },
    children: [
        {
            path: 'clzstu/:_stuId', component: StuClazzRecordList
        }
    ]
}];
export default {
    routers: routers
}